import supabase from '../supabaseClient';

// ── Supabase ─────────────────────────────────────────────────────
export const SB_URL = process.env.REACT_APP_SB_URL;
export const SB_KEY = process.env.REACT_APP_SB_KEY;

// ── Registros ────────────────────────────────────────────────────
export const sbGet = async (almacen_id) => { try { const { data, error } = await supabase.from('registros').select('*').eq('almacen_id', almacen_id).order('created_at', { ascending: false }); return error ? [] : data; } catch { return []; } };
export const sbInsert = async (row) => { try { const { data, error } = await supabase.from('registros').insert(row).select(); return error ? null : data; } catch { return null; } };
export const sbPatch = async (id, data) => { try { await supabase.from('registros').update(data).eq('id', id); } catch { } };
export const sbDelete = async (id) => { try { await supabase.from('registros').delete().eq('id', id); } catch { } };
export const sbUploadDoc = async (file) => {
  try {
    const ext = file.name.split(".").pop();
    const nombre = `doc_${Date.now()}.${ext}`;
    const r = await fetch(`${SB_URL}/storage/v1/object/Documentos-registros/${nombre}`, {
      method: "POST",
      headers: { "apikey": SB_KEY, "Authorization": `Bearer ${SB_KEY}`, "Content-Type": file.type },
      body: file
    });
    if (!r.ok) return null;
    return `${SB_URL}/storage/v1/object/Documentos-registros/${nombre}`;
  } catch { return null; }
};
export const sbSignedUrl = async (path) => {
  try {
    const marker = "/object/Documentos-registros/";
    const idx = path.indexOf(marker);
    const nombre = idx >= 0 ? path.slice(idx + marker.length) : path.split("/").pop();
    const r = await fetch("https://fmzyvyhgqhrpfpsdwtcu.supabase.co/functions/v1/get-signed-url", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${SB_KEY}` },
      body: JSON.stringify({ nombre })
    });
    const data = await r.json();
    return data.signedUrl || null;
  } catch { return null; }
};

// ── Usuarios (contraseñas en Supabase) ──────────────────────────
export const sbUpdatePass = async (email, nuevaPassword) => { try { const r = await fetch("https://fmzyvyhgqhrpfpsdwtcu.supabase.co/functions/v1/cambiar-password", { method: "POST", headers: { "Content-Type": "application/json", "Authorization": `Bearer ${process.env.REACT_APP_SB_KEY}` }, body: JSON.stringify({ email, nuevaPassword }) }); return r.ok; } catch { return false; } };
